// import Cookies from 'js-cookie';
import * as types from './actionTypes';

const initState = {
  login: false,
  loginStatus: false,
  loading: false,
  getMeLoading: false,
  error: null,
  user: {},
  me: {},
  register: false,
  registerError: {},
  registerSuccess: {},
  language: {},
  paymentMethodTypes: {},
  paymentStatus: {},
  businessCategories: {},
  otp: false,
  isMpinCreated: false,
  createMpin: false,
  employeeLogin: false,
  kpi: {},
  activeUrl: '',
  almaOnboardingDetails: {},
  metaParams: {},
  forgotPasswordErrors: {},
  resetPasswordLoading: false,
  resetPasswordSuccess: false,
  resetPasswordErrors: {},
  status: {
    email: false,
    otp: false,
    redirect: false,
  },
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case types.START_LOGIN:
      return {
        ...state,
        loading: true,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
        loginStatus: true,
      };
    case types.LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        loginStatus: false,
      };
    case types.LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case types.LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case types.SET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
        login: true,
      };
    case types.SET_LANGUAGE:
      return {
        ...state,
        language: action.data,
      };
    case types?.FORGOT_PASSWORD:
      return {
        ...state,
        loading: true,
      };
    case types.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotPasswordErrors: action.payload,
      };
    case types.FORGOT_PASSWORD_SUCESS:
      return {
        ...state,
        loading: false,
        status: {
          email: action?.payload?.email,
          otp: false,
          redirect: action?.payload?.redirect,
          verify_token: action?.payload?.verify_token,
        },
      };
    case types.RESET_PASSWORD:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordSuccess: false,
        resetPasswordErrors: {},
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: true,
        resetPasswordErrors: {},
      };
    case types.RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: false,
        resetPasswordErrors: action.payload || {},
      };
    case types.RESET_PASSWORD_RESET:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: false,
        resetPasswordErrors: {},
      };
    case types.EMAIL_VERIFIED:
      return {
        ...state,
        loading: true,
        status: { ...state.status, email: data },
      };
    case types.VERIFY_EMAIL_STATUS:
      return {
        ...state,
        loading: false,
        email: action?.payload?.email,
        status: action?.payload?.status,
      };
    case types.OTP_VERIFIED:
      return {
        ...state,
        loading: false,
        status: { ...state.status, otp: data },
      };
    case types.CHANGE_PASSWORD:
      return {
        ...state,
        loading: true,
      };
    case types.CHANGE_PASSWORD_SUCESS:
      return {
        ...state,
        loading: false,
        login: false,
        status: {
          email: false,
          otp: false,
          redirect: data,
        },
      };
    case types.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.SET_META_PARAMS:
      return {
        ...state,
        loading: false,
        metaParams: action.payload,
      };
    case types.REGISTER_REDIRECTION:
      return {
        ...state,
        register: action.payload,
      };
    case types.REGISTER_USER:
      return {
        ...state,
        loading: true,
      };
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        registerSuccess: action?.payload,
      };
    case types.REGISTER_ERROR:
      return {
        ...state,
        loading: false,
        registerError: action.payload,
      };
    case types.RESET_REGISTER_USER:
      return {
        ...state,
        registerError: {},
        registerSuccess: {},
      };
    case types.OTP_REDIRECTION:
      return {
        ...state,
        otp: action.payload,
      };
    case types.ISMPINCREATED_REDIRECTION:
      return {
        ...state,
        isMpinCreated: action.payload,
      };
    case types.CREATE_MPIN_REDIRECTION:
      return {
        ...state,
        createMpin: action.payload,
      };
    case types.EMPLOYEE_LOGIN_REDIRECTION:
      return {
        ...state,
        employeeLogin: action.payload,
      };
    case types.SET_KPI:
      return {
        ...state,
        kpi: action.payload,
      };
    case types.SET_ACTIVE_URL:
      return {
        ...state,
        activeUrl: action.payload,
      };
    case types.SET_BUSINESS_CATEGORIES:
      return {
        ...state,
        businessCategories: action.payload,
      };
    case types.SET_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };
    case types.SET_PAYMENT_TYPES:
      return {
        ...state,
        paymentMethodTypes: action.payload,
      };
    case types.SET_ALMA_ONBOARDING_STATUS:
      return {
        ...state,
        almaOnboardingDetails: { ...state.almaOnboardingDetails, status: action.payload },
      };
    case types.SET_ALMA_ONBOARDING_DETAILS:
      return {
        ...state,
        almaOnboardingDetails: {
          ...state.almaOnboardingDetails,
          data: action.payload?.data,
          label_status: action.payload?.label_status,
        },
      };
    case types.SET_ME:
      return {
        ...state,
        me: action.payload || {},
        getMeLoading: false,
      };
    case types.GET_ME:
      return {
        ...state,
        // getMeLoading: true,
      };
    case types.GET_ME_FAILURE:
      return {
        ...state,
        // getMeLoading: false,
      };
    case types.UPDATE_USER_ONBOARDING_CURRENT_STEP: {
      const step = action.payload;
      const user = state.user || {};
      const onboardingSteps = user.onboarding_steps
        ? { ...user.onboarding_steps, current_step: step }
        : { current_step: step };
      const nextUser = {
        ...user,
        current_step: step,
        onboarding_steps: onboardingSteps,
      };
      // ProtectedRoute reads auth.me.onboarding_steps before auth.user — keep both in sync
      let nextMe = state.me;
      if (state.me && Object.keys(state.me).length > 0) {
        const me = state.me;
        const meOnboarding = me.onboarding_steps
          ? { ...me.onboarding_steps, current_step: step }
          : { current_step: step };
        nextMe = {
          ...me,
          current_step: step,
          onboarding_steps: meOnboarding,
        };
      }
      return {
        ...state,
        user: nextUser,
        me: nextMe,
      };
    }
    case types.LOGOUT_SUCCESS:
      return initState;
    default:
      return state;
  }
};
export default AuthReducer;
